import Input from 'components/Input'
import TextBodyLight from 'components/TextBodyLight'
import {
  USER_MODEL_KEY,
  USER_MODEL_PLACEHOLDER
} from 'models/daos/user/constants'
import { getWebsiteUserUtil } from 'models/daos/user/utils'
import PropTypes from 'prop-types'
import React from 'react'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const ANALYTIC_EVENT = {
  VIEW_AUTHOR_WEBSITE: 'VIEW_AUTHOR_WEBSITE'
}

class UserRowWebsite extends React.Component {
  static defaultProps = {
    value: null,
    isEditing: null,
    hasNoPadding: null
  }

  static propTypes = {

    value: PropTypes.string,
    isEditing: PropTypes.bool,
    /**
     * Color of the input.
     * e.g. `error` => `red`
     * @type {string}
     */
    colorType: PropTypes.oneOf(Object.values(Input.COLOR_TYPE)),
    hasNoPadding: PropTypes.bool,
    onChange: PropTypes.func
  }

  handleChange (event, key, value) {
    this.props.onChange(value)
  }

  renderBody () {
    if (!this.props.isEditing) {
      return this.renderWebsite()
    }
    return this.renderEditWebsite()
  }

  renderEditWebsite () {
    const props = {
      value: this.props.value,
      name: USER_MODEL_KEY.WEBSITE,
      placeholder: USER_MODEL_PLACEHOLDER[USER_MODEL_KEY.WEBSITE],
      colorType: this.props.colorType,
      isBorderless: true,
      hasNoPadding: true,
      onChange: this.handleChange.bind(this)
    }
    return <Input {...props} />
  }

  handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_AUTHOR_WEBSITE)
  }

  renderWebsite () {
    const { value } = this.props
    return (
      <TextBodyLight
        fs='smaller'
        mt={0.2}
      >
        <a
          target='_blank'
          rel='noreferrer'
          href={getWebsiteUserUtil(value)}
          onClick={this.handleClick}
        >
          {value}
        </a>
      </TextBodyLight>
    )
  }

  render () {
    return (
      <>
        {this.renderBody()}
      </>
    )
  }
}

export default UserRowWebsite
